export default __webpack_public_path__ + "static/overlay_mobile-92fd4d13c5b5c9c0503b3fc99003e99f.jpeg";